import * as TextInputMask from 'react-masked-text';
import styled from 'styled-components';
import { TextFieldStyledCss } from './text-field.component.style';

const TextFieldMaskedStyled = styled(TextInputMask)`
  ${TextFieldStyledCss}
`;

export default TextFieldMaskedStyled;
